import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { freeBusyCache, FreeBusyRow } from 'owa-freebusy-cache';
import { ObservableMap } from 'mobx';
import { getComposeStore } from 'owa-calendar-compose-store-manager';

/**
 * Initializes the Free Busy Cache
 */
// TODO: Ideally, this would be a mutator subscribing to initCompose* actions, but those are
// currently written for SatchelV2.
export default function initFreeBusyCache(event: CalendarEvent, openedForm: string) {
    const viewState = getComposeStore().uiState;

    // Free Busy cache cannot be initialized twice, return if already initialized
    if (viewState.freeBusyData) {
        return;
    }

    let freeBusyData = (viewState.freeBusyData = new ObservableMap<
        string,
        ObservableMap<string, FreeBusyRow>
    >({}));

    freeBusyCache.initialize(freeBusyData);
}
